import React from 'react';
import { ScreenshotSection } from './ScreenshotSection';

interface MetadataContentProps {
  getCurrentPageName: () => string;
  screenshot: string | null;
  screenshotError: string | null;
  isCapturingScreenshot: boolean;
  onFileUpload: (file: File) => void;
  gaSessionId: string | null;
  gaClientId: string | null;
  sessionId?: string;
  getRolePlaySettingsMetadata: () => Record<string, any> | null;
  rolePlayData: any;
}

export const MetadataContent: React.FC<MetadataContentProps> = ({
  getCurrentPageName,
  screenshot,
  screenshotError,
  isCapturingScreenshot,
  onFileUpload,
  sessionId,
  getRolePlaySettingsMetadata,
  rolePlayData
}) => {
  return (
    <div className="metadata-content">
      <div className="metadata-item">
        <span className="metadata-label">Current Page:</span>
        <span className="metadata-value">{getCurrentPageName()}</span>
      </div>
      <div className="metadata-item">
        <span className="metadata-label">Timestamp:</span>
        <span className="metadata-value">{new Date().toLocaleString()}</span>
      </div>

      <ScreenshotSection
        screenshot={screenshot}
        screenshotError={screenshotError}
        isCapturingScreenshot={isCapturingScreenshot}
        onFileUpload={onFileUpload}
      />

      {sessionId && (
        <div className="metadata-item">
          <span className="metadata-label">Session ID:</span>
          <span className="metadata-value">{sessionId}</span>
        </div>
      )}

    </div>
  );
};